import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Expire from './Expire';
import Payment from './Payment';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//   <React.StrictMode>
     
//  {/* <Expire /> */}
//  {/* <Payment /> */}

//   </React.StrictMode>
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
